<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    title="退款/货确认"
    custom-class="customModal">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" >
      <el-form-item label="退还金额（元）:" prop="return_price">
        <el-input v-model="form.return_price"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';
  export default {
    name: 'confirmRefund',
    data() {
      return {
        visible: false,
        rules: {
          return_price: [{ required: true, message: '请填写退还金额', trigger: 'blur'}],
        },
        form:{
          return_price:"",
          return_check:"1"
        },
        orderData: {},
      }
    },
    methods: {
      open(data) {
        this.visible = true;
        this.orderData = data;
      },
      cancel() {
        this.visible = false;
      },
      async submit() {
        if(await this.$refs.form.validate()){
          await OrderService.refundConfirm({return_price:this.form.return_price,return_check:this.form.return_check, order_id: this.orderData.order_id}).then(()=>{
              this.cancel();
              this.$emit('success');
          });
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>